import { bemComponent } from '@99designs/utils/app';

export default bemComponent('button-group', 'ButtonGroup');
export const ButtonGroupItem = bemComponent('button-group__item', 'ButtonGroupItem');



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/ButtonGroup.jsx